/**
 * Product-card color chips: fade the card image instead of navigating.
 * Event delegation so collection filters can replace the grid.
 */
if (!window.gltheaaCardSwatchMediaInit) {
  window.gltheaaCardSwatchMediaInit = true;

  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gltheaa-card-swatch]');
    if (!button) return;

    const card = button.closest('[data-gltheaa-product-card]');
    if (!card) return;

    event.preventDefault();
    if (button.classList.contains('is-selected')) return;

    card.querySelectorAll('[data-gltheaa-card-swatch]').forEach((element) => {
      const selected = element === button;
      element.classList.toggle('is-selected', selected);
      element.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const src = button.getAttribute('data-card-image-src');
    const media = card.querySelector('[data-gltheaa-card-media]');
    if (!src || !media) return;

    const current = media.querySelector('img.is-active');
    const next = media.querySelector('img:not(.is-active)');
    if (!current || !next) return;
    if (current.getAttribute('src') === src) return;

    const srcset = button.getAttribute('data-card-image-srcset') || '';
    const sizes = button.getAttribute('data-card-image-sizes') || current.getAttribute('sizes') || '';
    const alt = button.getAttribute('data-card-image-alt') || current.getAttribute('alt') || '';

    const apply = () => {
      next.classList.add('is-active');
      current.classList.remove('is-active');
    };

    next.alt = alt;
    if (sizes) next.sizes = sizes;
    if (srcset) next.srcset = srcset;
    next.src = src;

    if (reduceMotionQuery.matches) {
      apply();
      return;
    }

    if (next.complete) {
      requestAnimationFrame(apply);
    } else {
      next.addEventListener('load', apply, { once: true });
      next.addEventListener('error', apply, { once: true });
    }
  });
}
